import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Input from "@material-ui/core/Input";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import SelectFilter from "react-select";
import Checkbox from "@material-ui/core/Checkbox";

import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";

import moment from "moment";

import MyButton from "../MyButton";

const myLib = require("../../lib/MyLib");
const server = require("../../lib/server");
const danhmuc = require("../../lib/DanhMucLayer");

class TaiKhoanEditDialog extends React.Component {
  constructor(props) {
    super(props);
    this.saveField = this.saveField.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.state = {
      open: props.visible,
      fullWidth: true,
      maxWidth: "sm",
      canSaved: false, //cho phep save hay khong
      dataChanged: false, //du lieu co su thay doi hay khong
      saving: false, //co dang save du lieu hay khong
      errorLog: "", //mo ta loi neu co
      loading_tausar: true, // co dang load ding danh muc nguon tin ko
      source_tausar: [], //danh muc options cho nguon tin
      loading_coquan: true,
      source_coquan: [],
      loading_user: true, //danh sach user chua co
      source_user: [],
      before:
        props.value === undefined
          ? {
              ThoiGian: new Date(),
            }
          : myLib.cloneObject(props.value), //thong tin truoc khi edit
      after:
        props.value === undefined
          ? {
              MaCQ: props.UserName === undefined ? null : props.UserName.MaCQ + '' ,
              UserName: props.UserName === undefined ? null : {label: props.UserName.UserName, value: props.UserName.UserName} ,
              Quyen: props.UserName === undefined ? {} : JSON.parse(props.UserName.Quyen),
            }
          : props.value, //thong tin dang edit
      validateStatus: { error: false }, //trang thai validate
    };
  }

  //ghi nhan gia tri nhap
  saveField = (fieldName, value, check) => {
    if (fieldName !== "Quyen") {
      var s = this.state;
      s.after[fieldName] = value;
      s.dataChanged = !myLib.isSame(s.before, s.after, ["UserName", "MaCQ"]);
      s.canSaved = s.dataChanged;
      this.setState(s);
    } else {
      var s = this.state;
      s.after.Quyen[value] = check;
      s.dataChanged = true;
      s.canSaved = s.dataChanged;
      this.setState(s);
    }
  };
  //submit thong tin ve DB
  handleSave = () => {
    if (this.props.EditMode !== "xoa") {
      var check = danhmuc.validate("nguoidung", this.state.after);
      console.log("check", check);
      if (!check.error) {
        //console.log(JSON.stringify(this.state.after));
        this.setState({ validateStatus: check, saving: true, errorLog: "" });
        server
          .post("taikhoan/save", this.state.after)
          .then((response) => {
            var before = {};
            var after = { ...this.state.after, UserName: response.UserName };
            Object.assign(before, after);
            this.setState({
              before: before,
              after: after,
              dataChanged: false,
              canSaved: false,
              saving: false,
              errorLog: "",
              saved: true,
            });
            //thong bao cho parent biet co data duoc saved
            if (this.props.onSaved) {
              this.props.onSaved(after);
            }
            this.handleClose(true);
          })
          .catch((error) =>
            this.setState({ saving: false, errorLog: error + "" })
          );
      } else {
        this.setState({ validateStatus: check });
      }
    } else {
      //thuc hien xoa
      this.setState({ saving: true, errorLog: "" });
      server
        .post("taikhoan/xoa", this.state.after)
        .then((response) => {
          var before = {};
          this.setState({
            saving: false,
            errorLog: "",
          });
          this.handleClose(true);
        })
        .catch((error) =>
          this.setState({ saving: false, errorLog: error + "" })
        );
    }
  };
  componentDidMount() {
    this.loadDanhMuc();
    this.loadEdit();
  }
  loadDanhMuc() {
    //load danh muc doi tac
    server
      .query("coquan/getall")
      .then((response) => {
        var list = [];
        response.map((item, index) =>
          list.push({ value: item.MaCQ, label: item.TenCoQuan })
        );
        this.setState({ source_coquan: list, loading_coquan: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading_coquan: false });
      });
    var user = this.props.UserName;
    if (user !== undefined) {
      //che do xoa thi hien thi them
      var new_item = { value: user.UserName, label: user.UserName };
      this.setState({
        source_user: [new_item],
        loading_user: false,
        after: { ...this.state.after, UserName: new_item },
      });
    } else
      server
        .query("taikhoan/getusers")
        .then((response) => {
          var list = [];
          response.map((item, index) =>
            list.push({ value: item.UserName, label: item.UserName })
          );
          this.setState({ source_user: list, loading_user: false });
        })
        .catch((error) => {
          console.log(error);
          this.setState({ loading_user: false });
        });
  }
  loadEdit() {
    //kiem tra xem co phai che do edit hay khong

  }
  handleClose = (result) => {
    this.setState({ open: false });
    if (this.props.onClose) {
      this.props.onClose(result);
    }
  };
  static getDerivedStateFromProps(props, state) {
    return { ...state };
  }
  render() {
    const { classes, theme } = this.props;
    return (
      <React.Fragment>
        <Dialog
          fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth}
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="max-width-dialog-title"
        >
          <DialogTitle id="max-width-dialog-title">
            <AppBar position="static">
              <Toolbar>
                <IconButton
                  edge="start"
                  className={classes.menuButton}
                  color="inherit"
                  aria-label="menu"
                >
                  <MenuIcon />
                </IconButton>
                <Typography variant="h6" className={classes.title}>
                  Tài khoản
                </Typography>
                {this.props.EditMode === "xoa" ? (
                  <Button color="inherit" onClick={this.handleSave}>
                    Xóa
                  </Button>
                ) : null}
                <Button
                  color="inherit"
                  onClick={() => this.handleClose(this.state.saved === true)}
                >
                  Thoát
                </Button>
              </Toolbar>
            </AppBar>
          </DialogTitle>
          <DialogContent>
            <form className={classes.form} noValidate autoComplete="off">
              <div style={{ height: 350 }}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <FormControl className={classes.formControl}>
                      <InputLabel id="demo-simple-select-label">
                        Cơ quan:
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className={classes.textbox}
                        autoWidth={true}
                        labelWidth={100}
                        value={this.state.after.MaCQ}
                        onChange={(event) =>
                          this.saveField("MaCQ", event.target.value)
                        }
                      >
                        {this.state.source_coquan.map((item, index) => (
                          <MenuItem value={item.value}>{item.label}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel id="labelQuoctich">Chọn tài khoản:</InputLabel>
                    {this.state.loading_user ? (
                      <CircularProgress />
                    ) : (
                      <SelectFilter
                        id="cboUsername"
                        options={this.state.source_user}
                        placeholder="---Chọn---"
                        labelId="labelQuoctich"
                        value={this.state.after.UserName}
                        onChange={(item) => this.saveField("UserName", item)}
                      ></SelectFilter>
                    )}
                  </Grid>
                  {/**Danh muc nguoi dung */}
                  {myLib.getQuyen().map((item, index) => (
                    global.User.Quyen[item.Code] === true ?
                    <Grid item xs={item.Code.indexOf("R9") >= 0 ? 4 : 6}>
                      <FormControlLabel
                        key={"K" + index}
                        control={
                          <Checkbox
                            checked={this.state.after.Quyen[item.Code]}
                            onChange={(event) =>
                              this.saveField(
                                "Quyen",
                                item.Code,
                                event.target.checked
                              )
                            }
                            name="chk1"
                          />
                        }
                        label={item.Name}
                      />
                    </Grid> : null
                  ))}
                  <Grid item xs={2}>
                    {this.state.canSaved && this.props.EditMode !== "xoa" ? (
                      <MyButton
                        onClick={this.handleSave}
                        color="primary"
                        text="Lưu"
                      />
                    ) : null}
                  </Grid>
                  <Grid item xs={10}>
                    {this.state.saving ? (
                      <CircularProgress />
                    ) : this.state.errorLog === "" ? null : (
                      this.state.errorLog
                    )}
                  </Grid>
                </Grid>
              </div>
            </form>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}
const styles = (theme) => ({
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  thoigian: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  textbox: {
    marginLeft: 1,
    marginRight: 1,
    width: 450,
  },
  uppercaseText: {
    textTransform: "uppercase",
  },
  normalPanel: {
    backgroundColor: "lightskyblue",
  },
  expandedPanel: {
    backgroundColor: "skyblue",
  },
});
export default withStyles(styles, { withTheme: true })(TaiKhoanEditDialog);
